(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultEbookController', DefaultEbookController)

	/** @ngInject */
	function DefaultEbookController($q, $state, $timeout, UnitService, HelperService, NotifyService, LeadService, ROUTES) {
		const vm = this;
		let qsMedia;
		let urlParams = getQueryVariable(window.location.search);

		vm.onSelectUnitState = state => {
			if (!state.Name) return

			HelperService.startLoading(".ebook");
			vm.unitCities = [];
			vm.lead.unitCity = null;
			vm.unities = [];
			vm.lead.unitName = null;

			$q.all(getCities(state.Name)).then(
				success => {
					HelperService.stopLoading(".ebook");
				},
				error => HelperService.errorCallback(error)
			)
		}

		vm.onSelectUnitCity = city => {
			if (!city.Name) return

			HelperService.startLoading(".ebook");
			vm.unities = [];
			vm.lead.unitName = null;

			$q.all(getUnits(city)).then(
				success => {
					HelperService.stopLoading(".ebook");
				},
				error => {
					HelperService.stopLoading(".ebook");
					HelperService.errorCallback(error);
				}
			)
		}

		vm.saveLead = () => {
			if (!vm.lead.unitName) {
				NotifyService.error('Ops,', 'Você deve selecionar a unidade Wizard mais próxima de você!');
				return
			}

			HelperService.startLoading(".ebook");

			let leadData = prepareLeadData();

			// if (typeof WebTracker != 'undefined') {
			// 	var queryStrings = WebTracker.getQueryStrings();

			// 	leadData.Hash = WebTracker.getHash();
			// 	leadData.BrowsingHistoryPostData = WebTracker.getHistory();
			// 	leadData.Parameter = WebTracker.getQueryStrings();

			// 	if (urlParams.CampaignId)
			// 		leadData.CampaignId = queryStrings.CampaignId;
			// }

			LeadService
				.postLead(leadData)
				.then(
					success => {
						if (success.Success == true) {
							LeadService.saveAstronautName(vm.lead.childName);
							LeadService.saveLeadData(vm.lead);

							NotifyService.notify({
								type: 'success',
								title: 'SUCESSO!',
								text: 'Seu cadastro foi realizado com sucesso! Clique no botão abaixo para baixar seu E-book grátis!',
								confirmButtonText: 'BAIXAR O EBOOK',
								allowEscapeKey: false,
								allowOutsideClick: false
							}, () => {
								$timeout(() => $state.go("default.countdown"), 500)
								window.open(`${ROUTES.API}/ebook-download`);
							});

							if (typeof WebTracker != 'undefined')
								WebTracker.clearHistory();

							HelperService.stopLoading(".ebook");

						} else {
							HelperService.stopLoading(".ebook");
							HelperService.errorCallback(success);
						}
					},
					error => {
						HelperService.stopLoading(".ebook");
						HelperService.errorCallback(error);
					}
				)
		}

		init();

		function getQueryVariable(hashBased) {
			var query;
			if (hashBased) {
				var pos = location.href.indexOf("?");
				if (pos == -1) return [];
				query = location.href.substr(pos + 1);
			} else {
				query = location.search.substr(1);
			}
			var result = {};
			query.split("&").forEach(function (part) {
				if (!part) return;
				part = part.split("+").join(" "); // replace every + with space, regexp-free version
				var eq = part.indexOf("=");
				var key = eq > -1 ? part.substr(0, eq) : part;
				var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
				var from = key.indexOf("[");
				if (from == -1) result[decodeURIComponent(key)] = val;
				else {
					var to = key.indexOf("]", from);
					var index = decodeURIComponent(key.substring(from + 1, to));
					key = decodeURIComponent(key.substring(0, from));
					if (!result[key]) result[key] = [];
					if (!index) result[key].push(val);
					else result[key][index] = val;
				}
			});
			return result;
		}

		function getStates() {
			let defer = $q.defer();

			UnitService
				.getUnitsStates()
				.then(
					success => {
						vm.unitStates = success.States;
						defer.resolve(success);
					},
					error => {
						NotifyService
							.notify({
								type: 'error',
								title: 'Ops!',
								text: 'Ocorreu um erro ao obter os Estados.',
								showConfirmButton: true,
								confirmButtonText: 'Tentar novamente',
								showCancelButton: false,
								allowEscapeKey: false,
								allowOutsideClick: false
							}, getStates);

						defer.reject(error);
					}
				)

			return defer
		}

		function getCities(stateName) {
			let defer = $q.defer();

			UnitService
				.getUnitsCities(stateName)
				.then(
					success => {
						vm.unitCities = success.Cities;
						defer.resolve(success);
					},
					error => {
						NotifyService
							.notify({
								type: 'error',
								title: 'Ops!',
								text: 'Ocorreu um erro ao obter as Cidades.',
								showConfirmButton: true,
								confirmButtonText: 'Tentar novamente',
								showCancelButton: false,
								allowEscapeKey: false,
								allowOutsideClick: false
							}, () => getCities(stateId));

						defer.reject(error);
					}
				)

			return defer
		}

		function getUnits(city) {
			let defer = $q.defer();

			const cityUrl = HelperService.convertToSlug(city.Name);

			UnitService
				.getUnitsByCity(cityUrl)
				.then(
					success => {
						if (success.Success) {
							if (!success.Units.length) {
								HelperService.stopLoading(".ebook");
								NotifyService
									.notify({
										type: 'error',
										title: 'Ops!',
										text: 'Não existem unidades participantes do future7 na cidade escolhida.',
										showConfirmButton: true,
										confirmButtonText: 'Ok',
										showCancelButton: false,
										allowEscapeKey: false,
										allowOutsideClick: false
									});

								return;
							}

							vm.unities = success.Units.reduce((acc, cur) => {
								acc.push({
									BusinessName: cur.fantasy_name,
									EmitterCode: cur.custom_code,
									Address: cur.street,
									AddressNumber: cur.number,
									AddressNeighborhood: cur.neighborhood
								});

								return acc;
							}, []);


							const isTeste = localStorage.getItem('setTeste');

							if (isTeste) {
								vm.unities.push({
									BusinessName: 'FRANQUIA TESTE WIZARD',
									EmitterCode: 41271,
									Address: 'Av. João Scarparo Netto',
									AddressNumber: 84,
									AddressNeighborhood: 'Lot. Center Santa Genebra'
								});
							}

							defer.resolve(success.Units);
						}
					},
					error => {
						NotifyService
							.notify({
								type: 'error',
								title: 'Ops!',
								text: 'Ocorreu um erro ao obter as unidades.',
								showConfirmButton: true,
								confirmButtonText: 'Tentar novamente',
								showCancelButton: false,
								allowEscapeKey: false,
								allowOutsideClick: false
							}, () => getUnits(city));

						defer.reject(error);
					}
				)

			return defer
		}

		function prepareLeadData() {
			let leadNote = `É ALUNO WIZARD: ${vm.lead.isStudent}`;

			let names = prepareName(vm.lead.parentName);

			let preparedData = {
				firstname: names.firstName,
				lastname: names.lastName,
				email: vm.lead.parentEmail,
				phone: vm.lead.parentPhone,
				selecione_o_estado: vm.lead.unitState.Name,
				selecione_a_cidade: vm.lead.unitCity.Name,
				selecione_a_unidade: vm.lead.unitName.BusinessName,
				unidade_id: vm.lead.unitName.custom_code,
				declaro_ter_mais_de_12_anos: "Sim",
				preferencia_de_contato: vm.lead.preferenciaDeContato.Name,
				campanha_id: 300088,
				campanha_nome: "future_7",
				marca: "wizard B2C",
				levantada_de_mao: "Sim",
				// comentarios: `Você já é aluno(a) da Wizard: ${objLead.find(e => e.name == "voce_ja_e_aluno_a_da_wizard_").value}`,
				// media_id: ,
				// media: objLead.find(e => e.name == "media").value,
				segmentacao: "a",
				observacao: leadNote,
				// lt_marketing_opt_in__c,
			};

			return preparedData;

			// return {
			// 	Name: vm.lead.parentName,
			// 	Email: vm.lead.parentEmail,
			// 	Telephone: vm.lead.parentPhone,
			// 	UnitEmitterCode: vm.lead.unitName.EmitterCode,
			// 	Note: leadNote,
			// 	ComercialCondition: 921,
			// 	CampaignId: qsMedia
			// }
		}

		function prepareName(fullName) {
			const names = fullName.split(' ');
			const firstName = names.length ? names[0] : fullName;
			const lastName = names.length ? names.slice(1).join(' ') : "";

			let ret = {
				firstName: firstName,
				lastName: lastName
			};

			return ret;
		}

		function init() {
			HelperService.startLoading(".ebook");
			qsMedia = HelperService.getCookie("qsMidia") || 57;

			vm.unitStates = [];

			vm.contactPreferences = [{
				Name: "E-mail"
			}, {
				Name: "Telefone"
			}, {
				Name: "WhatsApp"
			}];

			$q.all(getStates()).then(
				success => {
					HelperService.stopLoading(".ebook");
				},
				error => {
					HelperService.stopLoading(".ebook");
					HelperService.errorCallback(error);
				}
			)
		}

	}
}());